import { useEffect, useState } from "react";
import { getHomeContentAPI } from "../api";
import "../api/appCheck";
import FAQs from "../components/faqs";
import Features from "../components/features";
import Footer from "../components/footer";
import Gallery from "../components/gallery";
import Header from "../components/header";
import Hero from "../components/hero";
import { PLACEHOLDER_FEATURES } from "../constants";
import { CONTENT_TYPES } from "../constants/contentTypes";

function Home() {
  const [data, setData] = useState({});

  useEffect(() => {
    getHomeContentAPI().then((res) => {
      // console.log("[getHomeContentAPI]", res);
      setData(res);
    }).catch(() => {
      setData({
        [CONTENT_TYPES.features]: PLACEHOLDER_FEATURES
      })
    })
  }, []);

  return (
    <div className="home">
      <Header />
      <Hero />
      <Features data={data[CONTENT_TYPES.features]} />
      <Gallery />
      <FAQs data={data[CONTENT_TYPES.faqs]} />
      <Footer />
    </div>
  );
}

export default Home;
